import { Suspense, useState, useEffect, useRef } from 'react'
import { Await, defer, useLoaderData, useNavigate, Link } from 'react-router-dom'
import { event, link, gallery, advertisment, broadcast, getContent, airquality, subscription, configi, getStatistics, billboard, allLink } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import { Title } from './helper/DocumentTitle'
import Shimmer from './helper/Shimmer'
import styles from '../styles/module/Home.module.scss'
import Logo from './../logo.svg'
import Swal from 'sweetalert2'
import txtToSpeech from './helper/TTS'
import { toast } from 'react-hot-toast'
import { useAuth } from '../contexts/AuthContext'

const stateContent = [
  {
    name: `اردبیل`,
    color: `#37d73f`,
    cities: [`اردبیل`, `ثمرین`, `آراللو`, `هیر`],
  },
  {
    name: `اصلاندوز`,
    color: `#a735c0`,
    cities: [`اصلاندوز`],
  },
  {
    name: `انگوت`,
    color: `#183fba`,
    cities: [`انگوت`],
  },
  {
    name: `بیله سوار`,
    color: `#ecac3f`,
    cities: [`بیله سوار`, `جعفر آباد`],
  },
  {
    name: `پارس آباد`,
    color: `#8a7710`,
    cities: [`پارس آباد`, `مغانسر`, `اولتان`, `اسلام آباد`],
  },
  {
    name: `خلخال`,
    color: `#5922b0`,
    cities: [`خلخال`, `کلور`, `هشتجین`],
  },
  {
    name: `سرعین`,
    color: `#8ee115`,
    cities: [`سرعین`, `ایردموسی`],
  },
  {
    name: `کوثر`,
    color: `#37ac98`,
    cities: [`گیوی`, `فیروز آباد`],
  },
  {
    name: `گرمی`,
    color: `#f709e7`,
    cities: [`گرمی`, `زهرا`],
  },
  {
    name: `مشگین شهر`,
    color: `#9ed49a`,
    cities: [`مشگین شهر`, `آلنی`, `لاهرود`, `قصابه`, `رضی`, `مرادلو`, `فخرآباد`],
  },
  {
    name: `نمین`,
    color: `#b98cc8`,
    cities: [`نمین`, `آبی بیگلو`, `عنبران`],
  },
  {
    name: `نیر`,
    color: `#644e76`,

    cities: [`نیر`, `کورائیم`],
  },
]

export const loader = async () => {
  return defer({
    event: event(),
    link: link(),
    broadcast: broadcast(),
    statistics: getStatistics(),
  })
}

export default function Home() {
  const pageName = 'اردبیل من'
  Title('سامانه های متمرکز و یکپارچه اردبیل')
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState([])
  const [allLinkData, setAllLinkData] = useState([])
  const [backupData, setBackupData] = useState([])
  const [galleryImage, setGalleryImage] = useState()
  const [ads, setAds] = useState()
  const [statisticsData, setStatisticsData] = useState()
  const [billboardData, setBillboardData] = useState()
  const [configiData, setConfigiData] = useState()
  const [content, setContent] = useState()
  const [showCities, setShowCities] = useState(false)
  const [accessToekn, setAccessToekn] = useState()
  const [subCitiesContent, setSubCitiesContent] = useState([])
  const navigate = useNavigate()
  const txtSearchRef = useRef()
  const billboardRef = useRef(null)
  const { user } = useAuth()
  const [voiceAssistant, setVoiceAssistant] = useState(JSON.parse(localStorage.getItem('voice_assistant')) || false)

  function AletCopyTextToClipboard() {
    Swal.fire({
      position: 'bottom-end',
      icon: 'success',
      title: 'لینک با موفقیت کپی شد',
      showConfirmButton: false,
      timer: 1500,
    })
  }

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      var successful = document.execCommand('copy')
      var msg = successful ? 'successful' : 'unsuccessful'
      console.log('Fallback: Copying text command was ' + msg)
      AletCopyTextToClipboard()
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  }

  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text)
      return
    }
    navigator.clipboard.writeText(text).then(
      () => {
        console.log('Async: Copying to clipboard was successful!')
        AletCopyTextToClipboard()
      },
      function (err) {
        console.error('Async: Could not copy text: ', err)
      },
    )
  }

  const handleSearch = async () => {
    let dataFilter = allLinkData
    if (txtSearchRef.current.value !== '') {
      let filteredData = dataFilter.filter((item) => item.title.includes(txtSearchRef.current.value))
      if (filteredData.length > 0) setData(filteredData)
    } else setData(backupData)
  }

  const estimateDay = (date) => Math.floor((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))

  const nextSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft -= slideWidth
  }

  const previesSlide = () => {
    const slideWidth = document.querySelector('#slide').clientWidth
    document.querySelector('#slides-container').scrollLeft += slideWidth
  }

  const handleInputBoxFocus = () => {
    document.querySelector('#searchForm').classList.toggle('colorful-search-input')
  }

  const handleSubscribe = async () => {
    let sw = await navigator.serviceWorker.ready
    let push = await sw.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: 'BCKngXC0oWiRS4MfqnWKoRCfKCktono_7RN5FbrVN_hBlYrPIULJ7j7BNP2IzPK_YclQtqK03-v-oZKcdpit2nw',
    })
    console.log(JSON.stringify(push))
    return push
  }

  const readUserNotificationPermition = () => {
    if (!('Notification' in window)) return
    try {
      Notification.requestPermission().then((result) => {
        console.log(result)
        if (result === 'granted') {
          handleSubscribe().then((res) => {
            subscription(res)
          })
          // new Notification('با تشکر از عضویت شما', {
          //     body: `با موفقیت عضو خبرنامه شدید`,
          //     icon: Logo,
          // })
        }
      })
    } catch (error) {
      alert(error)
    }
  }

  const AccessToken = async () => {
    return await sessionStorage.getItem('AccessToken')
  }

  useEffect(() => {
    document.querySelector('header span').innerText = pageName

    AccessToken().then((res) => {
      setAccessToekn(res)
    })

    configi().then((res) => {
      console.log(res)
      setConfigiData(res)
    })

    link().then((res) => {
      setData(res)
      setBackupData(res)
      setIsLoading(false)
    })

    allLink().then((res) => {
      setAllLinkData(res)
      setIsLoading(false)
    })

    gallery().then((res) => {
      setGalleryImage(res)
    })

    getContent().then((res) => {
      setContent(res)
    })

    advertisment().then((res) => {
      setAds(res)

      let indexSlider = 0
      let sliderTimer = window.setInterval(() => {
        if (billboardRef.current === null) clearInterval(sliderTimer)
        billboardRef.current.href.baseVal = `${process.env.REACT_APP_UPLOAD}images/${res[indexSlider].banner}`
        if (indexSlider === res.length - 1) indexSlider = 0
        else indexSlider++
      }, 5000)
    })

    getStatistics().then((res) => {
      setStatisticsData(res)
    })

    billboard().then((res) => {
      setBillboardData(res)
    })
    link().then((res) => {
      console.log(res)
      setData(res)
      setBackupData(res)
      setIsLoading(false)
    })

    gallery().then((res) => {
      setGalleryImage(res)
    })

    billboard().then((res) => {
      setBillboardData(res)
    })

    readUserNotificationPermition()
  }, [])

  return (
    <section className={`${styles.section}`}>
      <div className="__frame" data-width={`xlarge`}>
        {configiData && (
          <div className={`${styles.heroBox} d-flex align-items-center justify-content-between`}>
            <p className={`${styles.heroDescription}`} style={{ marginTop: `0rem`, color: configiData[0].text_color, textShadow: '0 0 1px black' }}>
              {configiData[0].hero_text}
            </p>
            <div className={`${styles.emam}`}>
              <img alt={`l`} src={`https://api.ardabilman.ir/upload/images/l1405.jpg`} />
            </div>
            {/* 
          <div className={styles.heroLogo} style={{ backgroundImage: `url(${process.env.REACT_APP_UPLOAD}images/${configiData[0].hero})` }}>
           <img
            alt="خدمات جامع شهروندی اردبیل"
            src={HeroImage}
            draggable="false"
          /> 
          </div> */}
          </div>
        )}

        <Suspense fallback={<LoadingSpinner />}>
          <Await resolve={loaderData.broadcast} errorElement={<p></p>}>
            {(data) => {
              return (
                <div className={styles.broadcast} id="broadcast" style={{ border: '2px solid #0054a3' }}>
                  <ul>
                    <li>
                      <img alt={data[0].title} src={`${process.env.REACT_APP_UPLOAD}images/${data[0].img}`} />
                    </li>
                    <li>
                      <h5>{data[0].title}</h5>
                      <p>{data[0].message}</p>
                    </li>
                    <li>
                      <svg
                        onClick={() => {
                          document.querySelector('#broadcast').remove()
                        }}
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1.1 24.9154L0 23.8154L11.3577 12.4577L0 1.1L1.1 0L12.4577 11.3577L23.8154 0L24.9154 1.1L13.5577 12.4577L24.9154 23.8154L23.8154 24.9154L12.4577 13.5577L1.1 24.9154Z" />
                      </svg>
                    </li>
                  </ul>
                </div>
              )
            }}
          </Await>
        </Suspense>

        <Suspense fallback={<LoadingSpinner />}>
          <Await resolve={loaderData.event} errorElement={<p></p>}>
            {(data) => {
              return (
                <section className={styles.sliderWrapper}>
                  <div className={`animate__animated animate__fadeInDown ${styles.arrows}`} data-count={data.length}>
                    <ul>
                      <li>
                        <button onClick={() => previesSlide()}>&#8249;</button>
                      </li>
                      <li>
                        <button onClick={() => nextSlide()}>&#8250;</button>
                      </li>
                    </ul>
                  </div>

                  <ul className={`animate__animated animate__backInUp ${styles.slidesContainer}`} id="slides-container">
                    {data.map((item, i) => {
                      if (estimateDay(`${item.at}`) < 1) return false
                      return (
                        <li className={styles.slide} id="slide" key={i}>
                          <Link to={`/event/${item.id}`}>
                            <img alt={item.title} src={`${process.env.REACT_APP_UPLOAD}images/${item.img}`} />
                            <div className="d-flex flex-column align-items-start justify-content-between" style={{ height: '90%', flex: '1 1 100%' }}>
                              <h5>{item.title}</h5>
                              <p>بیشتر بخوانید</p>
                            </div>
                            <small>{estimateDay(`${item.at}`)}</small>
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </section>
              )
            }}
          </Await>
        </Suspense>

        {/* Searchbox */}
        <div className={styles.searchBox} id="searchForm">
          <img alt="لوگو" src={Logo} />

          <datalist id={`links`}>{allLinkData && allLinkData.map((item, i) => <option key={i} value={item.title} />)}</datalist>

          <form>
            <input list={`links`} type={`search`} maxLength={25} accessKey="q" onFocus={handleInputBoxFocus} onBlur={handleInputBoxFocus} ref={txtSearchRef} placeholder="جستجو در خدمات شهروندی" onKeyUp={(e) => handleSearch()} />
          </form>

          {/* <div className={styles.accessKeys}>
            <span>Alt</span>
            <span>+</span>
            <span>Shift</span>
            <span>+</span>
            <span>Q</span>
          </div> */}
        </div>

        {error && <>{error}</>}

        {isLoading && (
          <Shimmer>
            <div className={styles.shimmerGrid}>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
              <div className={styles.shimmerBox}>
                <span />
                <span />
              </div>
            </div>
          </Shimmer>
        )}

        {!error && data && (
          <>
            <div className={styles.grid}>
              {data.map((item, i) => (
                <div className={`${styles.item} noSelect js-tilt`} key={i}>
                  {voiceAssistant && item.voice_assistant !== null && <button onClick={(e) => txtToSpeech(e, item.voice_assistant)} />}

                  <Link
                    to={accessToekn === null && item.auth_required === '1' ? 'login' : `${item.type === 'external' ? `${item.path}?access_token=${accessToekn}` : item.path}`}
                    accessKey={`${item.accesskey}`}
                    title={item.lead}
                    tabIndex={++i}
                    // target={(item.type == 'internal') ? null : '_blank'}
                  >
                    <div
                      className={styles.item__body}
                      style={{
                        '--data-padding': '.5rem',
                        '--bg-url': `url(${process.env.REACT_APP_UPLOAD}images/${item.icon})`,
                      }}
                    >
                      {item.badge !== null && (
                        <small
                          style={{
                            '--color': JSON.parse(item.badge)[0].color,
                            '--background-color': JSON.parse(item.badge)[0].backgroundColor,
                          }}
                          className={`${JSON.parse(item.badge)[0].animation ? 'animate__animated animate__flash animate__delay-2s animate__infinite animate__slower' : ''}`}
                        >
                          {JSON.parse(item.badge)[0].name}
                        </small>
                      )}
                      <figure>
                        <img alt={item.title} src={`${process.env.REACT_APP_UPLOAD}images/${item.icon}`} style={{ '--color': item.backgroundColor }} />
                      </figure>
                      <div>
                        <h5>{item.title}</h5>
                        <p>{item.lead}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </>
        )}

        {billboardData && billboardData[0].status === '1' && (
          <div className={styles.billboard}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <svg
              // width="601"
              // height="503"
              viewBox="0 0 593 503"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="0" y="42" width="593" height="219" stroke={billboardData[0].body_color} fill="transparent" strokeWidth="6" id="banner" />

              <rect id="body_bottom" width="596" height="24" transform="translate(0 264)" fill={billboardData[0].body_color} />

              <a href={`${ads && ads[0].url}`} target="_blank">
                <image width="587" height="213" x="3" y="45" ref={billboardRef} preserveAspectRatio="none" href={`${process.env.REACT_APP_UPLOAD}images/${ads && ads[0].banner}`} clipPath="url(#banner)" />
              </a>
              <rect x="18" y="272" width="4" height="8" fill="white" />
              <rect x="32" y="272" width="27" height="8" fill="white" />
              <rect x="69" y="272" width="4" height="8" fill="white" />
              <rect x="83" y="272" width="27" height="8" fill="white" />
              <rect x="120" y="272" width="4" height="8" fill="white" />
              <rect x="134" y="272" width="27" height="8" fill="white" />
              <rect x="171" y="272" width="4" height="8" fill="white" />
              <rect x="185" y="272" width="27" height="8" fill="white" />
              <rect x="222" y="272" width="4" height="8" fill="white" />
              <rect x="236" y="272" width="27" height="8" fill="white" />
              <rect x="273" y="272" width="4" height="8" fill="white" />
              <rect x="287" y="272" width="27" height="8" fill="white" />
              <rect x="324" y="272" width="4" height="8" fill="white" />
              <rect x="338" y="272" width="27" height="8" fill="white" />
              <rect x="375" y="272" width="4" height="8" fill="white" />
              <rect x="389" y="272" width="27" height="8" fill="white" />
              <rect x="426" y="272" width="4" height="8" fill="white" />
              <rect x="440" y="272" width="27" height="8" fill="white" />
              <rect x="477" y="272" width="4" height="8" fill="white" />
              <rect x="491" y="272" width="27" height="8" fill="white" />
              <rect x="528" y="272" width="4" height="8" fill="white" />
              <rect x="542" y="272" width="27" height="8" fill="white" />
              <rect x="579" y="272" width="4" height="8" fill="white" />
              <path d="M355.5 288H244L260 321.5H267V503H333.5V321.5H339.5L355.5 288Z" fill={billboardData[0].body_color} />

              <text dy=".35em" textAnchor="middle" fill="red" x="300" y="300">
                بیلبورد مجازی
              </text>

              <image width="40" height="40" x="280" y="325" preserveAspectRatio="none" href={Logo} clipPath="url(#banner)" style={{ filter: 'brightness(0) invert(1)' }} />

              <path d="M83.7259 18H56.8587L37.0002 84H103L83.7259 18Z" fill="url(#paint0_linear_1035_2222)" />
              <path d="M198.976 18H172.109L152.25 84H218.25L198.976 18Z" fill="url(#paint1_linear_1035_2222)" />
              <path d="M314.226 18H287.359L267.5 84H333.5L314.226 18Z" fill="url(#paint2_linear_1035_2222)" />
              <path d="M429.476 18H402.609L382.75 84H448.75L429.476 18Z" fill="url(#paint3_linear_1035_2222)" />
              <path d="M544.726 18H517.859L498 84H564L544.726 18Z" fill="url(#paint4_linear_1035_2222)" />
              <path d="M63.0002 0H76.5002L81.5002 13H85.0002V18H76.5002L87.0002 39H83.5002L73.0002 18H55.0002V13H58.0002L63.0002 0Z" fill="black" />
              <path d="M179.167 0H192.667L197.667 13H201.167V18H192.167L201.5 38.9998L197.417 38.9917L188.167 18H171.167V13H174.167L179.167 0Z" fill="black" />
              <path d="M298.667 39V18H303.167V39H298.667Z" fill="black" />
              <path d="M307.167 0H293.667L288.667 13H285.667V18H315.667V13H312.167L307.167 0Z" fill="black" />
              <path d="M407.833 0H421.333L426.333 13H429.833V18H416.333L405.833 39H401.833L411.833 18H399.833V13H402.833L407.833 0Z" fill="black" />
              <path d="M524 0.00170898H537.5L542.5 13.0017H546V18.0017H528L518 38.9978L514 38.9983L524 18.0017H516V13.0017H519L524 0.00170898Z" fill="black" />
              <defs>
                <linearGradient id="paint0_linear_1035_2222" x1="70.0002" y1="18" x2="70.0002" y2="84" gradientUnits="userSpaceOnUse">
                  <stop stopColor={billboardData[0].light_start_color} stopOpacity="0.61" />
                  <stop offset="1" stopColor={billboardData[0].light_end_color} stopOpacity="0.22" />
                </linearGradient>
                <linearGradient id="paint1_linear_1035_2222" x1="185.25" y1="18" x2="185.25" y2="84" gradientUnits="userSpaceOnUse">
                  <stop stopColor={billboardData[0].light_start_color} stopOpacity="0.61" />
                  <stop offset="1" stopColor={billboardData[0].light_end_color} stopOpacity="0.22" />
                </linearGradient>
                <linearGradient id="paint2_linear_1035_2222" x1="300.5" y1="18" x2="300.5" y2="84" gradientUnits="userSpaceOnUse">
                  <stop stopColor={billboardData[0].light_start_color} stopOpacity="0.61" />
                  <stop offset="1" stopColor={billboardData[0].light_end_color} stopOpacity="0.22" />
                </linearGradient>
                <linearGradient id="paint3_linear_1035_2222" x1="415.75" y1="18" x2="415.75" y2="84" gradientUnits="userSpaceOnUse">
                  <stop stopColor={billboardData[0].light_start_color} stopOpacity="0.61" />
                  <stop offset="1" stopColor={billboardData[0].light_end_color} stopOpacity="0.22" />
                </linearGradient>
                <linearGradient id="paint4_linear_1035_2222" x1="531" y1="18" x2="531" y2="84" gradientUnits="userSpaceOnUse">
                  <stop stopColor={billboardData[0].light_start_color} stopOpacity="0.61" />
                  <stop offset="1" stopColor={billboardData[0].light_end_color} stopOpacity="0.22" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        )}

        {content && (
          <>
            <div className="card" style={{ marginTop: '1rem', borderRadius: '35px', border: '3px solid #333' }}>
              <div className="card__body text-center" style={{ textAlign: 'center' }}>
                <p style={{ fontSize: '1.2rem' }}>{content[0].billboard}</p>
              </div>
            </div>
          </>
        )}

        {galleryImage && (
          <div className="card" style={{ marginTop: '1rem', borderRadius: '35px', border: '3px solid #333' }}>
            <div className="card__header">
              <b>عکس روز</b>
            </div>
            <div className="card__body">
              <figure className={styles.gallery}>
                <img src={`${process.env.REACT_APP_UPLOAD}images/${galleryImage[0].url}`} style={{ borderRadius: '35px' }} />
                <figcaption>{galleryImage[0].name}</figcaption>
                <div>
                  <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 24.9C19.9333 24.9 21.5583 24.2417 22.875 22.925C24.1917 21.6083 24.85 19.9833 24.85 18.05C24.85 16.1167 24.1917 14.4917 22.875 13.175C21.5583 11.8583 19.9333 11.2 18 11.2C16.0667 11.2 14.4417 11.8583 13.125 13.175C11.8083 14.4917 11.15 16.1167 11.15 18.05C11.15 19.9833 11.8083 21.6083 13.125 22.925C14.4417 24.2417 16.0667 24.9 18 24.9ZM18 23.8C16.3667 23.8 15 23.25 13.9 22.15C12.8 21.05 12.25 19.6833 12.25 18.05C12.25 16.4167 12.8 15.05 13.9 13.95C15 12.85 16.3667 12.3 18 12.3C19.6333 12.3 21 12.85 22.1 13.95C23.2 15.05 23.75 16.4167 23.75 18.05C23.75 19.6833 23.2 21.05 22.1 22.15C21 23.25 19.6333 23.8 18 23.8ZM3.30001 31.4C2.53334 31.4 1.89167 31.1417 1.37501 30.625C0.85834 30.1083 0.600006 29.4667 0.600006 28.7V7.40001C0.600006 6.63334 0.85834 5.99167 1.37501 5.47501C1.89167 4.95834 2.53334 4.70001 3.30001 4.70001H9.40001L13.1 0.600006H22.9L26.6 4.70001H32.7C33.4667 4.70001 34.1083 4.95834 34.625 5.47501C35.1417 5.99167 35.4 6.63334 35.4 7.40001V28.7C35.4 29.4667 35.1417 30.1083 34.625 30.625C34.1083 31.1417 33.4667 31.4 32.7 31.4H3.30001ZM32.7 30.3C33.1667 30.3 33.55 30.15 33.85 29.85C34.15 29.55 34.3 29.1667 34.3 28.7V7.40001C34.3 6.96667 34.15 6.59167 33.85 6.27501C33.55 5.95834 33.1667 5.80001 32.7 5.80001H26.1L22.4 1.70001H13.6L9.90001 5.80001H3.30001C2.83334 5.80001 2.45001 5.95834 2.15001 6.27501C1.85001 6.59167 1.70001 6.96667 1.70001 7.40001V28.7C1.70001 29.1667 1.85001 29.55 2.15001 29.85C2.45001 30.15 2.83334 30.3 3.30001 30.3H32.7Z" />
                  </svg>
                  <span> {galleryImage[0].photographer}</span>
                </div>
              </figure>
            </div>
          </div>
        )}

        <div className={styles.statistics}>
          <h3 className={`mb-10`}>آمار استان اردبیل</h3>
          <div className="grid grid--fit grid--gap-1" style={{ '--data-width': '180px' }}>
            {statisticsData &&
              statisticsData.map((item, i) => {
                return (
                  <div
                    className="card"
                    key={i}
                    style={{ border: '3px solid #333', borderRadius: '25px', cursor: 'pointer' }}
                    onClick={() => {
                      if (item.name.toString().trim() == 'شهرستان') {
                        setShowCities(!showCities)
                        setSubCitiesContent([])
                      }
                    }}
                  >
                    <div className="card__body">
                      <figure>
                        <img alt={`icon`} src={`${process.env.REACT_APP_UPLOAD}images/${item.icon}`} />
                        <figcaption>
                          <span>{item.name}</span>
                          <small>{item.content}</small>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                )
              })}
          </div>
          {showCities && (
            <>
              <b style={{ marginTop: '1rem', display: 'block' }}>شهرستان های استان اردبیل:</b>
              <div className="grid grid--fit grid--gap-1 mt-30" style={{ '--data-width': '80px', marginTop: '1rem' }}>
                {stateContent.map((item, i) => {
                  return (
                    <div className="card" key={i} style={{ border: '3px solid #333', background: item.color, color: '#fff', borderRadius: '25px', cursor: 'pointer' }}>
                      <div
                        className={styles.statisticsBtn}
                        style={{ textAlign: 'center' }}
                        onClick={() => {
                          switch (item.name) {
                            case 'اردبیل':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'اردبیل') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['اردبیل', 'ثمرین', 'آراللو', 'هیر']])
                              break
                            case 'اصلاندوز':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'اصلاندوز') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['اصلاندوز', 'بران']])
                              break
                            case 'انگوت':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'انگوت') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['انگوت', 'زیوه']])
                              break
                            case 'بیله سوار':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'بیله سوار') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['بیله سوار', 'جعفر آباد']])
                              break
                            case 'پارس آباد':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'پارس آباد') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['پارس آباد', 'مغانسر', 'اولتان', 'اسلام آباد']])
                              break
                            case 'خلخال':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'خلخال') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['خلخال', 'کلور', 'هشتجین']])
                              break
                            case 'سرعین':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'سرعین') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['سرعین', 'ایردموسی']])
                              break
                            case 'کوثر':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'کوثر') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['گیوی', 'فیروز آباد']])
                              break
                            case 'گرمی':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'گرمی') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['گرمی', 'زهرا']])
                              break
                            case 'مشگین شهر':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'مشگین شهر') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['مشگین شهر', 'آلنی', 'لاهرود', 'قصابه', 'رضی', 'مرادلو', 'فخرآباد']])
                              break
                            case 'نمین':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'نمین') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['نمین', 'آبی بیگلو', 'عنبران']])
                              break
                            case 'نیر':
                              if (subCitiesContent.length > 0 && subCitiesContent[0] === 'نیر') {
                                setSubCitiesContent([])
                                return
                              }
                              setSubCitiesContent([item.name, item.color, ['نیر', 'کورائیم']])
                              break
                          }
                          console.log(subCitiesContent)
                        }}
                      >
                        {item.name}
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}

          {subCitiesContent && subCitiesContent.length > 0 && (
            <>
              <b style={{ marginTop: '1rem', display: 'block' }}>شهرهای {subCitiesContent[0]}:</b>
              <div className="grid grid--fit grid--gap-1 mt-30" style={{ '--data-width': '80px', marginTop: '1rem' }}>
                {subCitiesContent[2].map((item, i) => {
                  return (
                    <div className="card" key={i} style={{ border: '3px solid #333', color: '#fff', background: subCitiesContent[1], borderRadius: '25px', cursor: 'pointer' }}>
                      <div className="" style={{ textAlign: 'center' }}>
                        {item}
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}
